import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon fill="currentColor" {...props}>
      <polygon points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236" />
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 512 512',
  boxSize: '20px',
}

export default IconComp
